import { css } from "@repo/styled-system/css";
import { MediaManager } from "../features/media/MediaManager";

/** The venue-scoped media manager screen (media-uploads), mounted under `/v/:venueId/media`. */
export function Media() {
  return (
    <main className={css({ p: "8" })}>
      <MediaManager />
    </main>
  );
}
